import { SUBSCRIPTION_SUMMARY_QUERY, BRAND_RETENTION_SUMMARY_QUERY } from "@/constants/graphql/billing/billing";

export default {
  name: "SubscriptionReportMixin",
  data() {
    return {
      reportType: "SIGNUPS", // overwritten in compnent.
      subscriptionSummary: null,
      oneOnOneData: null,
      lifeData: null,
      gradData: null,
      clubData: null,
      brandData: null,
      selectedAcquisitionTypes: null,
      selectedCorporateTypes: null,
      selectedDiscountCategories: null,
      selectedPeriod: "days",
      noDiscounts: false,
      selectedTransitionProductTypes: null,
      selectedEndTypes: null,
    };
  },
  methods: {
    populateReport(current_series, previous_series, keyOption, title, label_1, label_2) {
      let dates = [];
      for (const key in current_series) {
        dates.push(key);
      }

      let current_data_series = [];
      let previous_data_series = [];

      for (const key in current_series) {
        current_data_series.push([key, current_series[key][keyOption]]);
      }

      for (const key in previous_series) {
        previous_data_series.push([key, previous_series[key][keyOption]]);
      }

      return {
        chart: {
          type: "line",
        },
        title: {
          text: title,
        },
        tooltip: {
          split: true,
          distance: 30,
          padding: 5,
        },
        credits: {
          enabled: false,
        },
        xAxis: {
          categories: dates,
          crosshair: {
            enabled: true,
          },
        },
        yAxis: {
          min: 0,
          title: {
            text: "# subscriptions",
          },
        },
        responsive: {
          rules: [
            {
              condition: {
                maxWidth: 500,
              },
              chartOptions: {
                legend: {
                  layout: "horizontal",
                  align: "center",
                  verticalAlign: "bottom",
                },
              },
            },
          ],
        },
        plotOptions: {},

        series: [
          {
            name: label_1,
            data: current_data_series,
            tooltip: {
              valueDecimals: 2,
              pointFormatter: function() {
                let y = this.y;
                let total = 0;
                for (let i = 0; i <= this.x; i++) {
                  total += this.series.points[i].y;
                }
                return "# <b>" + y + "</b></b><br/> # to date <b>" + total + "</b>";
              },
            },
          },
          {
            name: label_2,
            data: previous_data_series,
            color: "purple",
            tooltip: {
              valueDecimals: 2,
              pointFormatter: function() {
                let y = this.y;
                let total = 0;
                for (let i = 0; i <= this.x; i++) {
                  total += this.series.points[i].y;
                }
                return "# <b>" + y + "</b></b><br/> # to date <b>" + total + "</b>";
              },
            },
          },
        ],
      };
    },
    populateBrandRetentionReport(data) {
      const dates = [];
      for (const key in data) {
        dates.push(key);
      }

      const new_series = [];
      const returning_series = [];
      const continuing_series = [];
      const upgrading_series = [];
      const downgrading_series = [];

      for (const key in data) {
        new_series.push([key, data[key]["new"]]);
        returning_series.push([key, data[key]["returning"]]);
        continuing_series.push([key, data[key]["continuing"]]);
        upgrading_series.push([key, data[key]["upgrading"]]);
        downgrading_series.push([key, data[key]["downgrading"]]);
      }

      return {
        chart: {
          type: "line",
        },
        title: {
          text: "",
        },
        tooltip: {
          split: true,
          distance: 30,
          padding: 5,
        },
        credits: {
          enabled: false,
        },
        xAxis: {
          categories: dates,
          crosshair: {
            enabled: true,
          },
        },
        yAxis: {
          min: 0,
          title: {
            text: "Number of subscriptions",
          },
        },
        responsive: {
          rules: [
            {
              condition: {
                maxWidth: 500,
              },
              chartOptions: {
                legend: {
                  layout: "horizontal",
                  align: "center",
                  verticalAlign: "bottom",
                },
              },
            },
          ],
        },
        plotOptions: {},
        series: [
          {
            name: "New",
            data: new_series,
            color: "green",
            tooltip: {
              valueDecimals: 2,
              pointFormatter: function() {
                let y = this.y;
                let total = 0;
                for (let i = 0; i <= this.x; i++) {
                  total += this.series.points[i].y;
                }
                return "Subscriptions: <b>" + y + "</b></b><br/> Subscriptions to date: <b>" + total + "</b>";
              },
            },
          },
          {
            name: "Returning",
            data: returning_series,
            color: "purple",
            tooltip: {
              valueDecimals: 2,
              pointFormatter: function() {
                let y = this.y;
                let total = 0;
                for (let i = 0; i <= this.x; i++) {
                  total += this.series.points[i].y;
                }
                return "Subscriptions: <b>" + y + "</b></b><br/> Subscriptions to date: <b>" + total + "</b>";
              },
            },
          },
          {
            name: "Continuing",
            data: continuing_series,
            color: "yellow",
            tooltip: {
              valueDecimals: 2,
              pointFormatter: function() {
                let y = this.y;
                let total = 0;
                for (let i = 0; i <= this.x; i++) {
                  total += this.series.points[i].y;
                }
                return "Subscriptions: <b>" + y + "</b></b><br/> Subscriptions to date: <b>" + total + "</b>";
              },
            },
          },
          {
            name: "Upgrading",
            data: upgrading_series,
            color: "blue",
            tooltip: {
              valueDecimals: 2,
              pointFormatter: function() {
                let y = this.y;
                let total = 0;
                for (let i = 0; i <= this.x; i++) {
                  total += this.series.points[i].y;
                }
                return "Subscriptions: <b>" + y + "</b></b><br/> Subscriptions to date: <b>" + total + "</b>";
              },
            },
          },
          {
            name: "Downgrading",
            data: downgrading_series,
            color: "red",
            tooltip: {
              valueDecimals: 2,
              pointFormatter: function() {
                let y = this.y;
                let total = 0;
                for (let i = 0; i <= this.x; i++) {
                  total += this.series.points[i].y;
                }
                return "Subscriptions: <b>" + y + "</b></b><br/> Subscriptions to date: <b>" + total + "</b>";
              },
            },
          },
        ],
      };
    },
    populateBrandCancellationReport(data) {
      const dates = [];
      for (const key in data) {
        dates.push(key);
      }

      const no_transition_series = [];
      const continued_series = [];
      const returned_series = [];

      for (const key in data) {
        no_transition_series.push([key, data[key]["no_transition"]]);
        continued_series.push([key, data[key]["continued"]]);
        returned_series.push([key, data[key]["returned"]]);
      }

      return {
        chart: {
          type: "line",
        },
        title: {
          text: "",
        },
        tooltip: {
          split: true,
          distance: 30,
          padding: 5,
        },
        credits: {
          enabled: false,
        },
        xAxis: {
          categories: dates,
          crosshair: {
            enabled: true,
          },
        },
        yAxis: {
          min: 0,
          title: {
            text: "Number of subscriptions",
          },
        },
        responsive: {
          rules: [
            {
              condition: {
                maxWidth: 500,
              },
              chartOptions: {
                legend: {
                  layout: "horizontal",
                  align: "center",
                  verticalAlign: "bottom",
                },
              },
            },
          ],
        },
        plotOptions: {},
        series: [
          {
            name: "No transition",
            data: no_transition_series,
            color: "orange",
            tooltip: {
              valueDecimals: 2,
              pointFormatter: function() {
                let y = this.y;
                let total = 0;
                for (let i = 0; i <= this.x; i++) {
                  total += this.series.points[i].y;
                }
                return "Subscriptions: <b>" + y + "</b></b><br/> Subscriptions to date: <b>" + total + "</b>";
              },
            },
          },
          {
            name: "Continued",
            data: continued_series,
            color: "green",
            tooltip: {
              valueDecimals: 2,
              pointFormatter: function() {
                let y = this.y;
                let total = 0;
                for (let i = 0; i <= this.x; i++) {
                  total += this.series.points[i].y;
                }
                return "Subscriptions: <b>" + y + "</b></b><br/> Subscriptions to date: <b>" + total + "</b>";
              },
            },
          },
          {
            name: "Returned",
            data: returned_series,
            color: "purple",
            tooltip: {
              valueDecimals: 2,
              pointFormatter: function() {
                let y = this.y;
                let total = 0;
                for (let i = 0; i <= this.x; i++) {
                  total += this.series.points[i].y;
                }
                return "Subscriptions: <b>" + y + "</b></b><br/> Subscriptions to date: <b>" + total + "</b>";
              },
            },
          },
        ],
      };
    },
  },
  apollo: {
    subscriptionSummary: {
      query: SUBSCRIPTION_SUMMARY_QUERY,
      variables() {
        return {
          reportType: this.reportType,
          startDate: this.startDate,
          endDate: this.endDate,
          acquisitionTypes: this.selectedAcquisitionTypes,
          corporateTypes: this.selectedCorporateTypes,
          discountCategories: this.selectedDiscountCategories,
          period: this.selectedPeriod,
          noDiscounts: this.noDiscounts,
          transitionProductTypes: this.selectedTransitionProductTypes,
          endTypes: this.selectedEndTypes,
        };
      },
      skip() {
        return !this.endDate || !this.startDate;
      },
      fetchPolicy: "cache-and-network",
      result(response) {
        if (response.data && !response.loading) {
          this.loading = false;
          let data = response.data.subscriptionSummary;
          data = JSON.parse(data.data);
          this.oneOnOneData = this.populateReport(
            data.current,
            data.previous,
            "one-on-one",
            "One-on-one",
            "Current",
            "Previous"
          );
          this.lifeData = this.populateReport(data.current, data.previous, "life", "Life", "Current", "Previous");
          this.gradData = this.populateReport(data.current, data.previous, "grad", "Grad", "Current", "Previous");
          this.clubData = this.populateReport(data.current, data.previous, "club", "Club", "Current", "Previous");
        }
        if (response.error && response.error.gqlError?.message == "Permission Denied.") {
          this.$router.push("/no-access");
        }
      },
    },
    brandRetentionSummary: {
      query: BRAND_RETENTION_SUMMARY_QUERY,
      variables() {
        return {
          reportType: this.reportType,
          startDate: this.startDate,
          endDate: this.endDate,
          acquisitionTypes: this.selectedAcquisitionTypes,
          corporateTypes: this.selectedCorporateTypes,
          discountCategories: this.selectedDiscountCategories,
          period: this.selectedPeriod,
          noDiscounts: this.noDiscounts,
        };
      },
      skip() {
        return !this.endDate || !this.startDate;
      },
      fetchPolicy: "cache-and-network",
      result(response) {
        if (response.data && !response.loading) {
          this.loading = false;
          let data = response.data.brandRetentionSummary;
          data = JSON.parse(data.data);
          if (this.reportType == "SIGNUPS") {
            this.brandData = this.populateBrandRetentionReport(data);
          }
          if (this.reportType == "CANCELLATIONS") {
            this.brandData = this.populateBrandCancellationReport(data);
          }
        }
        if (response.error && response.error.gqlError?.message == "Permission Denied.") {
          this.$router.push("/no-access");
        }
      },
    },
  },
};
